module.exports = __webpack_public_path__ + "img/g3.65000e68.jpg";